import { IPageableResponse } from "@common/pagination/IPageable";
import { EMeasuringUnit } from "../interface/IUsage";
import { IUsageDetail } from "../interface/IUsageDetail";

interface IUsageDetailResponse {
    chargedUsageId: number;
    chargeStartDateTime: string;
    invoiceText: string;
    destinationNumber: string;
    destinationCountryCode: string;
    amount: number;
    amountFourDecimals: number;
    duration: number;
    measuringUnit: EMeasuringUnit;
    quantity: number;
}

export interface IUsageDetailListResponse {
    usage: IPageableResponse<IUsageDetailResponse>;
}

export const getResponseToState = (response: IUsageDetailListResponse): IPageableResponse<IUsageDetail> => ({
    content: response.usage.content.map((usage) => ({
        amount: usage.amount,
        amountFourDecimals: usage.amountFourDecimals,
        chargedUsageId: usage.chargedUsageId,
        chargeStartDateTime: usage.chargeStartDateTime,
        destinationCountryCode: usage.destinationCountryCode,
        duration: usage.duration,
        destinationNumber: usage.destinationNumber,
        invoiceText: usage.invoiceText,
        measuringUnit: usage.measuringUnit,
        quantity: usage.quantity,
    })),
    totalPages: response.usage.totalPages,
});
